import { render } from "./Flip.vue?vue&type=template&id=b06f65e2&scoped=true"
const script = {}

import "./Flip.vue?vue&type=style&index=0&id=b06f65e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b06f65e2"]])

export default __exports__